{
  "pricing": {
    "loadingInfo": "Загрузка информации о ценах...",
    "noPriceInfo": "Информация о ценах недоступна",
    "takeGoldmakingNextLevel": "Поднимите добычу золота на новый уровень",
    "subscribeFrom": "Подпишитесь всего за {{price}} {{currency}} / месяц. Без обязательств. Отмените в любое время.",
    "goldSubActive": "Ваша текущая подписка {{type}} действует до {{expiration}}",
    "goldSubTitle": "Gold-подписка активна",
    "goldSubUpgradeTitle": "Готовы перейти на Premium?",
    "goldSubHeading": "С возвращением, золотодобытчик",
    "goldSubHeadingSubtitle": "Спасибо, что вы Gold-участник — ваша подписка в одном взгляде.",
    "upgradeToPremiumContact": "Для перехода на premium обратитесь к нашей команде в",
    "discordName": "Flipping Pal Discord",
    "manageBilling": "Управление выставлением счетов и методами оплаты",
    "manageBillingOpening": "Открытие...",
    "monthly": "Ежемесячно",
    "yearly": "Ежегодно",
    "saveUpTo": "Экономьте до {{percent}}% при годовой подписке.",
    "mostPopular": "Самый популярный",
    "perMonth": "/месяц",
    "perYear": "/год",
    "startDate": "Дата начала: {{date}}",
    "nextPaymentDate": "Следующая дата оплаты: {{date}}",
    "subscriptionEnds": "Подписка заканчивается: {{date}}",
    "reasonPaymentFailed": "Причина: Ошибка платежа",
    "reasonCancelled": "Причина: Отменена",
    "accessTools": "Доступ к инструментам",
    "resumeSubscription": "Возобновить подписку",
    "cancelSubscription": "Отменить подписку",
    "processing": "Обработка...",
    "subscribeNow": "Подписаться сейчас",
    "getStarted": "Начать",
    "switchToMonthly": "Перейти на ежемесячную",
    "switchToYearly": "Перейти на ежегодную",
    "upgradeToPremium": "Перейти на Premium",
    "upgradeLabel": "Перейти на Premium ({{billing}})",
    "downgradeToBasic": "Понизить до Basic",
    "downgradeLabel": "Понизить до Basic ({{billing}})",
    "switchPlan": "Сменить план",
    "currentPlan": "Текущий план",
    "statusActive": "Активна",
    "statusExpired": "Истекла",
    "statusCanceled": "Отменена",
    "statusInCancelation": "В процессе отмены",
    "showMoreFeatures": "+ ещё {{count}} функций",
    "showFewerFeatures": "Скрыть"
  },
  "trial": {
    "activatedTitle": "Пробный период активирован!",
    "activatedSubtitle": "Вот что вы получаете — и что вас ждёт",
    "startExploring": "Начать изучение",
    "viewPlans": "Просмотреть планы",
    "trialActive": "Бесплатный пробный период активен",
    "daysRemaining": "{{count}} день осталось",
    "expires": "Истекает {{date}}",
    "trialLabel": "Пробный",
    "compareButton": "Сравнить планы",
    "trialEnded": "Ваш бесплатный пробный период закончился. Подпишитесь выше, чтобы продолжить использовать FlippingPal!",
    "haveTrialCode": "Есть пробный код?",
    "trialCodeHint": "Используйте",
    "trialCodeHint2": "на нашем",
    "discordServer": "сервере Discord",
    "trialCodeHint3": "чтобы получить его",
    "activateButton": "Активировать пробный период",
    "activatingButton": "Активация"
  },
  "features": {
    "basic": {
      "0": "Ограничено 10 реалмами продажи",
      "1": "Инструмент жилья для флиппинга и дропшипа декора",
      "2": "Инструмент межреалмового флиппинга",
      "3": "Инструмент дропшипа ограничен 3 результатами на предмет",
      "4": "Статистика реалма",
      "5": "Генератор списков TSM",
      "6": "До 50 снайп-оповещений для Discord",
      "7": "Пресеты фильтров ограничены 3",
      "8": "Поддержка клиентов от команды"
    },
    "premium": {
      "0": "Неограниченное количество реалмов продажи",
      "1": "Инструмент жилья для флиппинга и дропшипа декора",
      "2": "Инструмент межреалмового флиппинга",
      "3": "Инструмент дропшипа увеличен до 10 результатов на предмет",
      "4": "Статистика реалма",
      "5": "Генератор списков TSM",
      "6": "Инструмент анализа инвентаря",
      "7": "До 9999 снайп-оповещений для Discord",
      "8": "Пресеты фильтров ограничены 50",
      "9": "Совместное использование фильтров с функцией импорта/экспорта",
      "10": "Поддержка клиентов от команды",
      "11": "Приоритетная поддержка"
    }
  },
  "loading": "Загрузка информации о подписке..."
}
